'use client';

import { useTranslations } from 'next-intl';
import { RoundLoading } from './custom-round-loading';

export const LoadingPage = () => {
    const transBrand = useTranslations('BrandInfo');
    return (
        <div
            aria-label='loading-page'
            aria-hidden
            className='absolute inset-0 z-10 flex w-full cursor-progress items-center justify-center bg-gray-200 bg-opacity-50'
        >
            <RoundLoading size='large' />

            <div className='sr-only'>
                <h1 className='text-balance'>
                    {transBrand('BrandInfo_AppName')}
                </h1>
                <p className='text-balance'>
                    {transBrand('BrandInfo_AppShortDescription')}
                </p>
            </div>
        </div>
    );
};
